// --- React
import React from "react";
// --- External UI Libraries
import Pillbox from "@dtci/spellbook/Pillbox";
// --- Utilities
import { roleMapping } from "tap/utils/userRoles.js";

/**
 * Cell renderer that displays user roles as pillbox badges.
 * Maps role IDs from data.spaUserRoleIds to role names using roleMapping.
 * @returns {Function} AG Grid cell renderer component
 */
export const PillboxCellRenderer = () => {
  const Renderer = ({ data }) => {
    if (
      !Array.isArray(data?.spaUserRoleIds) ||
      data?.spaUserRoleIds.length === 0
    )
      return null;

    const roles = data.spaUserRoleIds
      .map((id) => roleMapping.find((r) => r.id === id))
      .filter(Boolean);

    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: "4px",
          padding: "4px 0",
        }}
      >
        {roles.map((role, idx) => (
          <Pillbox
            key={role.id || idx}
            badgeRole="listitem"
            color="primary"
            light
            showClose={false}
            size="small"
          >
            {role.roleName || role.id}
          </Pillbox>
        ))}
      </div>
    );
  };
  return Renderer;
};
